import React, { useState, memo } from 'react';
import { Button, ButtonGroup, Row, Col, Form } from 'react-bootstrap';
import {
  defaultGeneralData,
  healthCalculation,
  separateDateTime,
} from '../../../utils/helpers';
import GeneralExaminationBtn from '../partials/generalExaminationBtn';
import { keyframes } from 'styled-components';

const MedicalPatientInfo = ({
  patientInfo,
  setPatientInfo,
  selectedOnExamination,
  setSelectedOnExamination,
  appointmentInfo,
}) => {
  let generalExaminations = selectedOnExamination?.generalExaminations;
  generalExaminations = generalExaminations || defaultGeneralData();
  const [dob, setDob] = useState('');
  const [fieldName, setFieldName] = useState('');
  const [isGeneralExaminationBtn, setIsGeneralExaminationBtn] = useState(false);
  const [btnInputArray, setBtnInputArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ageOrDob, setAgeOrDob] = useState(true);
  const [errors, setErrors] = useState({});

  //for new appointment
  const [activityLevel, setActivityLevel] = useState('');

  const getErrorMessage = (inputName) => {
    return errors[inputName] ? errors[inputName] : '';
  };

  const handleInput = (fieldName, val) => {
    setFieldName('');
    if (
      fieldName === 'bloodGroup' ||
      fieldName === 'diseases' ||
      fieldName === 'patientOutcome' ||
      fieldName === 'systemicExamination'
    ) {
      generalExaminations[fieldName] =
        generalExaminations[fieldName] === val ? '' : val;
    } else if (fieldName === 'systolic' || fieldName === 'diastolic') {
      generalExaminations.bloodPressure[fieldName] = val;
    } else if (
      fieldName === 'pulse' ||
      fieldName === 'pulseUnit' ||
      fieldName === 'pulseType'
    ) {
      if (fieldName === 'pulseType') {
        generalExaminations.pulseInfo[fieldName] =
          generalExaminations.pulseInfo[fieldName] === val ? '' : val;
      } else {
        generalExaminations.pulseInfo[fieldName] = val;
      }
    } else if (fieldName === 'temperature' || fieldName === 'temperatureUnit') {
      generalExaminations.temperatureInfo[fieldName] = val;
    } else if (fieldName === 'temperatureType') {
      generalExaminations.temperatureInfo[fieldName] = generalExaminations
        .temperatureInfo[fieldName]
        ? ''
        : val;
    } else if (
      fieldName === 'weight' ||
      fieldName === 'weightUnit' ||
      fieldName === 'weightShowInPrescription'
    ) {
      generalExaminations.weightInfo[fieldName] = val;
      checkAndCallHealthParameters();
    } else if (
      fieldName === 'feet' ||
      fieldName === 'inch' ||
      fieldName === 'cm' ||
      fieldName === 'heightUnit'
    ) {
      generalExaminations.heightInfo[fieldName] = val;
      checkAndCallHealthParameters();
    } else if (
      fieldName === 'weight' ||
      fieldName === 'weightUnit' ||
      fieldName === 'weightShowInPrescription'
    ) {
      generalExaminations.weightInfo[fieldName] = val;
      checkAndCallHealthParameters();
    }
    selectedOnExamination.generalExaminations = generalExaminations;
    setSelectedOnExamination({ ...selectedOnExamination });
    setIsGeneralExaminationBtn(false);
  };

  const handleBtnInputArray = (field) => {
    setFieldName(field);
    let buttonArray;
    if (field === 'systolic') {
      buttonArray = [
        70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
      ];
    } else if (field === 'diastolic') {
      buttonArray = [40, 50, 60, 70, 80, 90, 100, 110, 120];
    } else if (field === 'pulse') {
      buttonArray = [
        40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120,
      ];
    } else if (field === 'temperature') {
      buttonArray = [95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
    } else if (field === 'weight') {
      buttonArray = [
        40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120,
        125, 130,
      ];
    } else if (field === 'feet') {
      buttonArray = [3, 4, 5, 6, 7];
    } else if (field === 'inch') {
      buttonArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
    } else if (field === 'idealWeight') {
      buttonArray = [40, 45, 50, 55, 60, 65, 70, 75, 80];
    }
    setIsGeneralExaminationBtn(isGeneralExaminationBtn ? false : true);
    setBtnInputArray(buttonArray);
  };

  const checkAndCallHealthParameters = (activityLevel = '') => {
    console.log('checking parameters...');
    if (
      (generalExaminations.heightInfo?.feet &&
        generalExaminations.heightInfo?.heightUnit &&
        generalExaminations.weightInfo?.weight &&
        generalExaminations.weightInfo?.weightUnit) ||
      (generalExaminations.heightInfo?.cm &&
        generalExaminations.heightInfo?.heightUnit &&
        generalExaminations.weightInfo?.weight &&
        generalExaminations.weightInfo?.weightUnit)
    ) {
      const ageObj = separateDateTime(patientInfo?.dob);
      const parameters = {
        ...generalExaminations.heightInfo,
        ...generalExaminations.weightInfo,
        gender: patientInfo?.gender,
        age: ageObj?.years,
        activityLevel: activityLevel
          ? activityLevel
          : generalExaminations.activityLevel,
      };
      const healthResults = healthCalculation(parameters);
      console.log('healthResults results: ', healthResults);
      generalExaminations['bmi'] = healthResults.bmi;
      generalExaminations['bmr'] = healthResults.bmr;
      generalExaminations['bsa'] = healthResults.bsa;
      generalExaminations['tdee'] = healthResults.tdee;
      selectedOnExamination.generalExaminations = generalExaminations;
      setSelectedOnExamination({ ...selectedOnExamination });
    }
  };

  const handleActivityLevel = (e) => {
    generalExaminations['activityLevel'] = e.target.value;
    selectedOnExamination.generalExaminations = generalExaminations;
    setSelectedOnExamination({ ...selectedOnExamination });
    checkAndCallHealthParameters(e.target.value);
  };

  const handleActivityLevelClear = () => {
    handleActivityLevel({ target: { value: '' } });
  };

  const handlePhysicalExamination = (type, value) => {
    if (type === 'note') {
      generalExaminations.physicalExamination.note = value;
    } else {
      const oldValues = generalExaminations.physicalExamination.values;
      if (oldValues?.includes(value)) {
        const filteredValues = oldValues.filter((item) => item !== value);
        generalExaminations.physicalExamination.values = [...filteredValues];
      } else {
        generalExaminations.physicalExamination.values = [...oldValues, value];
      }
    }
    console.log(generalExaminations.physicalExamination.values);
    selectedOnExamination.generalExaminations = generalExaminations;
    setSelectedOnExamination({ ...selectedOnExamination });
  };

  const handleComorbidity = (type, value) => {
    if (type === 'others') {
      generalExaminations.comorbidity.others = value;
    } else {
      const oldValues = generalExaminations.comorbidity.values;
      if (oldValues?.includes(value)) {
        const filteredValues = oldValues.filter((item) => item !== value);
        generalExaminations.comorbidity.values = [...filteredValues];
      } else {
        generalExaminations.comorbidity.values = [...oldValues, value];
      }
    }
    selectedOnExamination.generalExaminations = generalExaminations;
    setSelectedOnExamination({ ...selectedOnExamination });
  };

  return (
    <div
      className="patient-info"
      style={{ height: '452px', overflowY: 'auto' }}
    >
      <Row>
        <Col xs={12} sm={12} md={6}>
          <Form.Group>
            <Form.Label className="d-block label-bold">
              <span>Height</span>
              <ButtonGroup
                className="patient-info-btn-group mb-1"
                aria-label="Basic example"
              >
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.heightInfo?.heightUnit === 'Ft'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  style={{ marginRight: '.25rem' }}
                  onClick={() => handleInput('heightUnit', 'Ft')}
                >
                  Ft
                </Button>
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.heightInfo?.heightUnit === 'Cm'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={() => handleInput('heightUnit', 'Cm')}
                >
                  Cm
                </Button>
              </ButtonGroup>
            </Form.Label>
            <div className="d-flex justify-content-space-between">
              {generalExaminations?.heightInfo?.heightUnit === 'Ft' && (
                <>
                  <Form.Control
                    className="mr-3"
                    size="sm"
                    type="number"
                    placeholder="Enter Feet"
                    defaultValue={generalExaminations?.heightInfo?.feet}
                    value={generalExaminations?.heightInfo?.feet}
                    onClick={() => handleBtnInputArray('feet')}
                    onChange={(e) => handleInput('feet', e.target.value)}
                  />
                  <Form.Control
                    size="sm"
                    type="number"
                    defaultValue={generalExaminations?.heightInfo?.inch}
                    value={generalExaminations?.heightInfo?.inch}
                    placeholder="Inch"
                    onClick={() => handleBtnInputArray('inch')}
                    onChange={(e) => handleInput('inch', e.target.value)}
                  />
                </>
              )}
              {generalExaminations?.heightInfo?.heightUnit === 'Cm' && (
                <>
                  <Form.Control
                    className="mr-3"
                    size="sm"
                    type="number"
                    placeholder="Enter CM"
                    defaultValue={generalExaminations?.heightInfo?.feet}
                    value={generalExaminations?.heightInfo?.feet}
                    onClick={() => handleBtnInputArray('feet')}
                    onChange={(e) => handleInput('feet', e.target.value)}
                  />
                </>
              )}
            </div>
          </Form.Group>
          {isGeneralExaminationBtn &&
            (fieldName === 'feet' || fieldName === 'inch') && (
              <Row>
                <Col md={fieldName === 'feet' ? -1 : 0}></Col>
                <Col md={fieldName === 'feet' ? 0 : 9}>
                  <GeneralExaminationBtn
                    fieldName={fieldName}
                    btnInputArray={btnInputArray}
                    onClickAction={handleInput}
                  />
                </Col>
              </Row>
            )}
        </Col>
        <Col xs={12} sm={12} md={6} className="">
          <Form.Group>
            <Form.Label className="d-block label-bold weight-responsive">
              <span>Weight</span>
              <ButtonGroup
                className="patient-info-btn-group"
                aria-label="Basic example"
              >
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.weightInfo?.weightUnit === 'KG'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  style={{ marginRight: '.25rem' }}
                  onClick={() => handleInput('weightUnit', 'KG')}
                >
                  KG
                </Button>
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.weightInfo?.weightUnit === 'Pound'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={() => handleInput('weightUnit', 'Pound')}
                >
                  Pound
                </Button>
              </ButtonGroup>
            </Form.Label>
            <div className="d-flex justify-content-space-between">
              <Form.Control
                className="form-control-sm"
                type="text"
                value={generalExaminations?.weightInfo?.weight}
                defaultValue={generalExaminations?.weightInfo?.weight}
                placeholder="Weight"
                onChange={(e) => handleInput('weight', e.target.value)}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} className="mt-3">
          <Form.Group>
            <Form.Label className="d-block label-bold">
              <span>Activity Level:</span>
            </Form.Label>
            <div className="justify-content-space-between-wrap pt-1">
              <label className="activityLevel">
                <input
                  type="radio"
                  name="options"
                  value="Sedentary"
                  checked={generalExaminations['activityLevel'] === 'Sedentary'}
                  onChange={handleActivityLevel}
                />
                Sedentary
              </label>

              <label className="activityLevel">
                <input
                  type="radio"
                  name="options"
                  value="Light Active"
                  checked={
                    generalExaminations['activityLevel'] === 'Light Active'
                  }
                  onChange={handleActivityLevel}
                />
                Light Active
              </label>

              <label className="activityLevel">
                <input
                  type="radio"
                  name="options"
                  value="Moderately Active"
                  checked={
                    generalExaminations['activityLevel'] === 'Moderately Active'
                  }
                  onChange={handleActivityLevel}
                />
                Moderately Active
              </label>

              <label className="activityLevel">
                <input
                  type="radio"
                  name="options"
                  value="Overy Active"
                  checked={
                    generalExaminations['activityLevel'] === 'Overy Active'
                  }
                  onChange={handleActivityLevel}
                />
                Overy Active
              </label>

              <label className="activityLevel">
                <input
                  type="radio"
                  name="options"
                  value="Extra Active"
                  checked={
                    generalExaminations['activityLevel'] === 'Extra Active'
                  }
                  onChange={handleActivityLevel}
                />
                Extra Active
              </label>

              <Button
                variant="outline-dark"
                className="btn-sm"
                type="button"
                style={{ width: '6rem' }}
                onClick={() => {
                  handleActivityLevelClear();
                }}
              >
                Clear
              </Button>
            </div>
          </Form.Group>
        </Col>
      </Row>

      <Row
        style={{
          marginTop: '.4rem',
          fontSize: '1rem',
        }}
      >
        <Col md={6} sm={12}>
          <div className="justify-content-space-between-wrap">
            <p>
              <label className="label-bold">BMR: </label>{' '}
              {generalExaminations?.bmr}
            </p>
            <p>
              <label className="label-bold">TDEE: </label>{' '}
              {generalExaminations?.tdee}
            </p>
          </div>
        </Col>
        <Col md={6} sm={12}>
          <div className="justify-content-space-between-wrap">
            <p>
              <label className="label-bold">BSA: </label>{' '}
              {generalExaminations?.bsa}
            </p>
            <p>
              <label className="label-bold">BMI: </label>{' '}
              {generalExaminations?.bmi}
            </p>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={12} md={6} className="mt-2">
          <Form.Group>
            <Form.Label className="d-block label-bold">
              <span>Temperature</span>
              <ButtonGroup
                className="patient-info-btn-group"
                aria-label="Basic example"
              >
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.temperatureInfo?.temperatureUnit ===
                    'F'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  style={{ marginRight: '.25rem' }}
                  onClick={() => handleInput('temperatureUnit', 'F')}
                >
                  <span>&#8451;</span>
                </Button>
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.temperatureInfo?.temperatureUnit ===
                    'C'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={() => handleInput('temperatureUnit', 'C')}
                >
                  <span>&#8457;</span>
                </Button>
              </ButtonGroup>
            </Form.Label>
            <div className="d-flex justify-content-space-between">
              <Form.Control
                size="sm"
                type="number"
                defaultValue={generalExaminations?.temperatureInfo?.temperature}
                value={generalExaminations?.temperatureInfo?.temperature}
                placeholder="Temperature"
                onClick={() => handleBtnInputArray('temperature')}
                onChange={(e) => handleInput('temperature', e.target.value)}
              />
              <Button
                className="ml-2 btn-sm-customize"
                size="sm"
                variant={
                  generalExaminations?.temperatureInfo?.temperatureType ===
                  'Normal'
                    ? 'primary'
                    : 'outline-secondary'
                }
                style={{ width: '10rem' }}
                onClick={(e) => handleInput('temperatureType', 'Normal')}
              >
                Normal
              </Button>
            </div>
          </Form.Group>
          {isGeneralExaminationBtn && fieldName === 'temperature' && (
            <Row>
              <Col style={{ display: 'flex', justifyContent: 'left' }}>
                <GeneralExaminationBtn
                  fieldName={fieldName}
                  btnInputArray={btnInputArray}
                  onClickAction={handleInput}
                />
              </Col>
            </Row>
          )}
        </Col>
        <Col xs={12} sm={12} md={6} className="mt-2">
          <Form.Group>
            <Form.Label className="d-block label-bold">
              <span>Pulse</span>
              <ButtonGroup
                className="patient-info-btn-group mb-1"
                aria-label="Basic example"
              >
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.pulseInfo?.pulseUnit === 'PM'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  style={{ marginRight: '.25rem' }}
                  onClick={() => handleInput('pulseUnit', 'PM')}
                >
                  PM
                </Button>
                <Button
                  size="sm"
                  variant={
                    generalExaminations?.pulseInfo?.pulseUnit === 'BPM'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={() => handleInput('pulseUnit', 'BPM')}
                >
                  BPM
                </Button>
              </ButtonGroup>
            </Form.Label>
            {/* <div className="d-flex justify-content-space-between"> */}
            <Row>
              <Col>
                <Form.Control
                  className="fixed-height mb-1"
                  style={{ width: '8rem' }}
                  size="sm"
                  type="number"
                  placeholder="Pulse"
                  defaultValue={generalExaminations?.pulseInfo?.pulse}
                  onClick={() => handleBtnInputArray('pulse')}
                  onChange={(e) => handleInput('pulse', e.target.value)}
                />
              </Col>
              <Col>
                <Button
                  className="ml-2 btn-sm-customize fixed-height"
                  size="sm"
                  style={{ width: '8rem', marginBottom: '5px' }}
                  variant={
                    generalExaminations?.pulseInfo?.pulseType === 'Regular'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={(e) => handleInput('pulseType', 'Regular')}
                >
                  Regular
                </Button>
              </Col>
              <Col>
                <Button
                  className="btn-sm-customize fixed-height"
                  size="sm"
                  style={{ width: '8rem', marginBottom: '5px' }}
                  variant={
                    generalExaminations?.pulseInfo?.pulseType === 'Irregular'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={(e) => handleInput('pulseType', 'Irregular')}
                >
                  Irregular
                </Button>
              </Col>
              <Col>
                <Button
                  className="ml-2 btn-sm-customize fixed-height"
                  size="sm"
                  style={{ width: '8rem' }}
                  variant={
                    generalExaminations?.pulseInfo?.pulseType === 'Drop Beat'
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  onClick={(e) => handleInput('pulseType', 'Drop Beat')}
                >
                  Drop Beat
                </Button>
              </Col>

              {/* </div> */}
            </Row>
          </Form.Group>
          {isGeneralExaminationBtn && fieldName === 'pulse' && (
            <Row>
              <Col xs={12} sm={12} md={12}>
                <GeneralExaminationBtn
                  fieldName={fieldName}
                  btnInputArray={btnInputArray}
                  onClickAction={handleInput}
                />
              </Col>
            </Row>
          )}
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={12} md={6} className="mt-2">
          <Form.Group>
            <Form.Label className=" d-block d-flex justify-content-space-between label-bold">
              <span>Blood Pressure</span>
              <span style={{ paddingLeft: '65px' }}>mm HG</span>
            </Form.Label>
            <div className="d-flex justify-content-space-between">
              <Form.Control
                className="mr-2"
                size="sm"
                type="number"
                placeholder="Systolic"
                defaultValue={generalExaminations?.bloodPressure?.systolic}
                value={generalExaminations?.bloodPressure?.systolic}
                onClick={() => handleBtnInputArray('systolic')}
                onChange={(e) => handleInput('systolic', e.target.value)}
              />
              <div style={{ fontSize: '25px' }}>/</div>
              <Form.Control
                className="ml-2"
                size="sm"
                type="number"
                placeholder="Diastolic"
                defaultValue={generalExaminations?.bloodPressure?.diastolic}
                value={generalExaminations?.bloodPressure?.diastolic}
                onClick={() => handleBtnInputArray('diastolic')}
                onChange={(e) => handleInput('diastolic', e.target.value)}
              />
            </div>
          </Form.Group>
          {isGeneralExaminationBtn &&
            (fieldName === 'systolic' || fieldName === 'diastolic') && (
              <Row>
                <Col md={12}>
                  <GeneralExaminationBtn
                    fieldName={fieldName}
                    btnInputArray={btnInputArray}
                    onClickAction={handleInput}
                  />
                </Col>
              </Row>
            )}
        </Col>{' '}
        <Col xs={12} sm={12} md={6} className="mt-1">
          <Form.Group>
            <Form.Label className="d-block  label-bold">Blood Group</Form.Label>
            <div className="common-small-btn">
              {[
                'O+',
                'O-',
                'A+',
                'A-',
                'B+',
                'B-',
                'AB+',
                'AB-',
                'Unknown',
              ].map((group) => (
                <Button
                  key={group}
                  variant={
                    generalExaminations?.bloodGroup === group
                      ? 'primary'
                      : 'outline-secondary'
                  }
                  className="blood-group-btn"
                  onClick={() => handleInput('bloodGroup', group)}
                >
                  {group}
                </Button>
              ))}
            </div>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} className="mt-3">
          <Form.Group>
            <Form.Label className=" label-bold">
              <span>Physical examination:</span>
            </Form.Label>
            <div className="justify-content-space-between-wrap pt-1">
              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="Anaemic"
                  checked={generalExaminations?.physicalExamination?.values.includes(
                    'Anaemic',
                  )}
                  onChange={(e) =>
                    handlePhysicalExamination('values', e.target.value)
                  }
                />
                Anaemic
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="Jundice"
                  checked={generalExaminations?.physicalExamination?.values.includes(
                    'Jundice',
                  )}
                  onChange={(e) =>
                    handlePhysicalExamination('values', e.target.value)
                  }
                />
                Jundice
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="Odema"
                  checked={generalExaminations?.physicalExamination?.values.includes(
                    'Odema',
                  )}
                  onChange={(e) =>
                    handlePhysicalExamination('values', e.target.value)
                  }
                />
                Odema
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="Purpura"
                  checked={generalExaminations?.physicalExamination?.values.includes(
                    'Purpura',
                  )}
                  onChange={(e) =>
                    handlePhysicalExamination('values', e.target.value)
                  }
                />
                Purpura
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="Lymph Nodes"
                  checked={generalExaminations?.physicalExamination?.values.includes(
                    'Lymph Nodes',
                  )}
                  onChange={(e) =>
                    handlePhysicalExamination('values', e.target.value)
                  }
                />
                Lymph Nodes
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="Palpable"
                  checked={generalExaminations?.physicalExamination?.values.includes(
                    'Palpable',
                  )}
                  onChange={(e) =>
                    handlePhysicalExamination('values', e.target.value)
                  }
                />
                Palpable
              </label>

              <Form.Control
                size="sm"
                type="text"
                placeholder="Note"
                value={generalExaminations?.physicalExamination?.note || ''}
                onChange={(e) =>
                  handlePhysicalExamination('note', e.target.value)
                }
                style={{ minWidth: '8rem', width: '30%' }}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={12} md={12} className="mt-3">
          <Form.Group>
            <Form.Label className="d-block label-bold">
              <span>Comorbidity:</span>
            </Form.Label>
            <div className="d-flex justify-content-space-between-wrap pt-1">
              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="Hypertension"
                  checked={generalExaminations?.comorbidity?.values.includes(
                    'Hypertension',
                  )}
                  onChange={(e) => handleComorbidity('values', e.target.value)}
                />
                Hypertension
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="Diabetes"
                  checked={generalExaminations?.comorbidity?.values.includes(
                    'Diabetes',
                  )}
                  onChange={(e) => handleComorbidity('values', e.target.value)}
                />
                Diabetes
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="CKD"
                  checked={generalExaminations?.comorbidity?.values.includes(
                    'CKD',
                  )}
                  onChange={(e) => handleComorbidity('values', e.target.value)}
                />
                CKD
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="ISD"
                  checked={generalExaminations?.comorbidity?.values.includes(
                    'ISD',
                  )}
                  onChange={(e) => handleComorbidity('values', e.target.value)}
                />
                ISD
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="CODD"
                  checked={generalExaminations?.comorbidity?.values.includes(
                    'CODD',
                  )}
                  onChange={(e) => handleComorbidity('values', e.target.value)}
                />
                CODD
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="Asthma"
                  checked={generalExaminations?.comorbidity?.values.includes(
                    'Asthma',
                  )}
                  onChange={(e) => handleComorbidity('values', e.target.value)}
                />
                Asthma
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="POD"
                  checked={generalExaminations?.comorbidity?.values.includes(
                    'POD',
                  )}
                  onChange={(e) => handleComorbidity('values', e.target.value)}
                />
                POD
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="PUD"
                  checked={generalExaminations?.comorbidity?.values.includes(
                    'PUD',
                  )}
                  onChange={(e) => handleComorbidity('values', e.target.value)}
                />
                PUD
              </label>

              <label className="activityLevel">
                <input
                  type="checkbox"
                  name="options"
                  value="Hypothyroid"
                  checked={generalExaminations?.comorbidity?.values.includes(
                    'Hypothyroid',
                  )}
                  onChange={(e) => handleComorbidity('values', e.target.value)}
                />
                Hypothyroid
              </label>

              <Form.Control
                size="sm"
                type="text"
                placeholder="Others"
                value={generalExaminations?.comorbidity?.others}
                onChange={(e) => handleComorbidity('others', e.target.value)}
                style={{ minWidth: '8rem', width: '30%' }}
              />
            </div>
          </Form.Group>
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={12} md={4} className="pt-3">
          <Form.Group>
            <Form.Label className="d-block  label-bold">
              <span>Diseases</span>
            </Form.Label>

            <Form.Control
              className="form-control-sm"
              type="text"
              value={generalExaminations?.diseases}
              // defaultValue={generalExaminations?.weightInfo?.weight}
              placeholder="Diseases"
              onChange={(e) => handleInput('diseases', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={12} md={4} className="pt-3">
          <Form.Group>
            <Form.Label className="d-block  label-bold">
              <span>Patient Outcome</span>
            </Form.Label>

            <Form.Control
              className="form-control-sm"
              type="text"
              value={generalExaminations?.patientOutcome}
              // defaultValue={generalExaminations?.weightInfo?.weight}
              placeholder="Patient Outcome"
              onChange={(e) => handleInput('patientOutcome', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={12} md={4} className="pt-3">
          <Form.Group>
            <Form.Label className="d-block  label-bold">
              <span>Systemic Examination</span>
            </Form.Label>

            <Form.Control
              className="form-control-sm"
              type="text"
              value={generalExaminations?.systemicExamination}
              // defaultValue={generalExaminations?.weightInfo?.weight}
              placeholder="Systemic Examination"
              onChange={(e) =>
                handleInput('systemicExamination', e.target.value)
              }
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default memo(MedicalPatientInfo);
